import { render, staticRenderFns } from "./QualificationRecordDetails.vue?vue&type=template&id=6fd39e9e"
import script from "./QualificationRecordDetails.vue?vue&type=script&lang=ts"
export * from "./QualificationRecordDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports